import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { StoryDeprecated } from "@hermes/api-model-editorial";
import { Settings } from "@hermes/app-core";
/**
 * Manages editorial story.
 */
@Injectable()
export class StoryService {
    constructor(private http: HttpClient, private settings: Settings) {}

    public fetchStoryFromPath(path: string): Observable<StoryDeprecated> {
        const params = new HttpParams({
            fromObject: {
                path,
            },
        });
        return this.http.get<StoryDeprecated>(
            `${this.settings.apiUrl}/editorial/story`,
            {
                params,
            },
        );
    }

    public fetchStoryHomePage(): Observable<StoryDeprecated> {
        return this.http.get<StoryDeprecated>(
            `${this.settings.apiUrl}/homepage`,
        );
    }
}
